import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from '../../app-routing.module';
import { SharedModule } from '../shared/shared.module';
import { DashboardComponent } from './dashboard.component';
import { DashboardWidgetComponent } from './dashboard-widget/dashboard-widget.component';
import { NgChartsModule } from 'ng2-charts';
import { DragulaModule } from 'ng2-dragula';

@NgModule({
  declarations: [
    DashboardComponent,
    DashboardWidgetComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    NgChartsModule,
    DragulaModule,
    AppRoutingModule
  ]
})
export class DashboardModule { }
